/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('taric.duty', ['taric.duty.calculate', 'taric.duty.exchangerates', 'taric.duty.meursing']).config(function ($stateProvider) {
    $stateProvider.state('taric.duty', {
        abstract: true,
        url: '/duty',
        template: '<ui-view></ui-view>'
    }).state('taric.duty.calculate', {
        url: '/calculate?frm&cc&sd&d&ads&co&cu&ad&ur&pv',
        templateUrl: 'taric/duties/calculate/cd.tmpl.html',
        resolve: {
            initializeCalculateDuty : function(CalculateDutyModel, $stateParams){
                if (!$stateParams.ad) {
                    CalculateDutyModel.initializeCalculateDuty();
                }
            },
            goToDataTab : function(CalculateDutyModel, $stateParams, $filter, CommonHelper){
                if ($stateParams.frm){
                    // Reset Calculation Result when opening Calculate Duty use case from other use cases.
                    CalculateDutyModel.resetCalculationResult();

                    if ($stateParams.cc){
                        CalculateDutyModel.getCalculationInput().commodityCode = $filter('commodityCode')($stateParams.cc);
                    }
                    if ($stateParams.d){
                        if ($stateParams.d === 'I' || $stateParams.d === 'E'){
                            CalculateDutyModel.getCalculationInput().tradeDirection = $stateParams.d;
                        }
                    }
                    if ($stateParams.sd){
                        var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                        if (inputDate) {
                            CalculateDutyModel.getCalculationInput().simulationDate = inputDate;
                            CalculateDutyModel.updateCalculationSupportVersion();
                        }
                    }

                    CalculateDutyModel.goToNextTab('commodity');

                    if ($stateParams.co){
                        CalculateDutyModel.getCalculationInput().country = $stateParams.co;

                        CalculateDutyModel.getPreferenceCodesAndSupplementaryUnit(CalculateDutyModel.getCalculationInput().commodityCode,
                            CalculateDutyModel.getCalculationInput().country,
                            CalculateDutyModel.getCalculationInput().simulationDate,
                            CalculateDutyModel.getCalculationInput().tradeDirection,
                            CalculateDutyModel.getCalculationInput().countryOfPreferentialOrigin,
                            CalculateDutyModel.getCalculationInput().version
                            ).then(function (result) {

                            CalculateDutyModel.preferenceCodesAndSupplementaryUnit = result;
                        });
                        CalculateDutyModel.getCalculationInput().preferenceCode = null;
                    }

                    if ($stateParams.ur) {
                        CalculateDutyModel.getCalculationInput().includeUnreleased = ($stateParams.ur === 'true');
                    }
                }
            },
            goToAdditionalCodesTab : function(CalculateDutyModel, $stateParams) {
                // If return from search meursing additional code
                if ($stateParams.ad) {
                    // Return from meursing search with additional code
                    if ($stateParams.ad === '7XXX') {
                        // Dummy value for "not selected"
                        CalculateDutyModel.meursingAdditionalCode = null;
                    } else {
                        CalculateDutyModel.meursingAdditionalCode = $stateParams.ad;
                    }
                    CalculateDutyModel.goToNextTab('data');
                }
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/duties/calculate');
            },
            setupMenu: function (MenuModel) {

            	MenuModel.setHelpIndex(this.name);
            	MenuModel.notifyObservers();
            }
        }
    }).state('taric.duty.exchangerates', {
        url: '/exchangerates?mu&ds&de&l',
        templateUrl: 'taric/duties/exchangerates/er-exchangerates.tmpl.html',
        controller : 'ExchangeRatesController as exchangeRatesCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: function(ExchangeRatesModel, $stateParams, $translate, CommonHelper){
                ExchangeRatesModel.reset();
                if ($stateParams.mu) {
                    ExchangeRatesModel.getSearchCriteria().monetaryUnit = $stateParams.mu;
                }
                if ($stateParams.ds){
                    var fromDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (fromDate) {
                        ExchangeRatesModel.getSearchCriteria().fromDate = fromDate;
                    }
                }
                if ($stateParams.de){
                    var toDate = CommonHelper.parseInputDate($stateParams.de);
                    if (toDate) {
                        ExchangeRatesModel.getSearchCriteria().toDate = toDate;
                    }
                }
                if ($stateParams.l){
                    $translate.use($stateParams.l);
                }
            },
            monetaryUnits: function(MonetaryUnitsModel, ExchangeRatesModel) {
                return MonetaryUnitsModel.customsValueMonetaryUnits(ExchangeRatesModel.getSearchCriteria().fromDate);
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/duties/exchangerates');
            },
            setupMenu: function (MenuModel) {

            	MenuModel.setHelpIndex(this.name);
            	MenuModel.notifyObservers();
            }
        }
    }).state('taric.duty.meursing', {
        url: '/meursing?sd&cu&co&ad&mf&mp&sg&si&l&frm',
        templateUrl: 'taric/duties/meursing/meursing-search.tmpl.html',
        controller : 'SearchMeursingController as searchMeursingCtrl',
        reloadOnSearch: false,
        resolve:{
            initializeData : function($stateParams, MeursingModel, CommonHelper, $translate){
                if ($stateParams.frm !== 'adcoLookup'){
                    MeursingModel.reset();
                    if ($stateParams.frm) {
                        MeursingModel.cancelButtonEnabled = true;
                        MeursingModel.from = $stateParams.frm;
                    }
                } else {
                    MeursingModel.resetSearchResult();
                }
                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        MeursingModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.cu) {
                    MeursingModel.getSearchCriteria().dutyCurrency = $stateParams.cu;
                }
                if ($stateParams.co) {
                    MeursingModel.getSearchCriteria().country = $stateParams.co;
                }
                if ($stateParams.ad) {
                    MeursingModel.getSearchCriteria().useAdditionalCode = true;
                    MeursingModel.getSearchCriteria().additionalCode = $stateParams.ad;
                } else {
                    if ($stateParams.mf) {
                        MeursingModel.getSearchCriteria().milkFatId = $stateParams.mf;
                    }
                    if ($stateParams.mp) {
                        MeursingModel.getSearchCriteria().milkProteinId = $stateParams.mp;
                    }
                    if ($stateParams.sg) {
                        MeursingModel.getSearchCriteria().starchGlucoseId = $stateParams.sg;
                    }
                    if ($stateParams.si) {
                        MeursingModel.getSearchCriteria().sucroseIsoglucoseId = $stateParams.si;
                    }
                }
                if ($stateParams.l){
                    $translate.use($stateParams.l);
                }
            },
            countries: function(GeographicalAreaModel, MeursingModel, $stateParams){
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if (!$stateParams.frm && $stateParams.sd && $stateParams.cu && $stateParams.co) {
                    result = GeographicalAreaModel.getCountriesOfOrigin(MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            },
            currencies: function(MonetaryUnitsModel, MeursingModel){
                return MonetaryUnitsModel.dutyMonetaryUnits(MeursingModel.getSearchCriteria().simulationDate);
            },
            meursingItemLists: function(MeursingModel, $stateParams){
                var result = null;
                // Only get meursingItemLists when it is not searched with additional code.
                if (!$stateParams.ad) {
                    result = MeursingModel.initMeursingItemLists(MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            },
            milkProteinsList: function(MeursingModel, $stateParams){
                var result = null;
                // Only get milkProteinsList when it is not searched with additional code.
                if (!$stateParams.ad && $stateParams.mf) {
                    result = MeursingModel.updateMilkProteinItems($stateParams.mf, MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            },
            sucroseIsoglucoseList: function(MeursingModel, $stateParams){
                var result = null;
                // Only get sucroseIsoglucoseList when it is not searched with additional code.
                if (!$stateParams.ad && $stateParams.sg) {
                    result = MeursingModel.updateSucroseIsoglucoseItems($stateParams.sg, MeursingModel.getSearchCriteria().simulationDate);
                }
                return result;
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/duties/meursing');
            },
            setupMenu: function (MenuModel) {
            	MenuModel.enablePrintable();
            	MenuModel.disableExportable();
            	MenuModel.setHelpIndex(this.name);
            	MenuModel.notifyObservers();
            }
        }
    });

});



// WEBPACK FOOTER //
// ./app/taric/duties/taric-duties.js